import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Map from "./Map";
import "../sass/Dashboard.scss";
import Heading from "./Heading";
import Graph from "./Graph";
import Menu from "./Menu";
import Title from "./Title";
import { isMobile } from "react-device-detect";
import { ContentContext } from "./context/ContentContext";
import { DomainContext } from "./context/DomainNameContext";
import { ChoosenDataSet } from "./context/ChoosenDataSet";
import { NewAddDomain } from "./context/NewAddDomain";
import { CityContext } from "./context/CityContext";
import Alert from "./Alert";
import { SelectedDataSet } from "./context/SelectedDataset";
import { LayerContext } from "./context/LayerContext";
import { ScrollToContext } from "./context/ScrollToContext";
import { LoadingContext } from "./context/Loading";
import { PlayContext } from "./context/PlayContext";
import { toast } from "react-toastify";
import { LayerAddContext } from "./context/AddedLayer";
import screenfull from "screenfull";
import BlogPosting from "./BlogPosting";
import { FaPlus } from "react-icons/fa";
import ConnectNowInterface from "../components/ConnectNowInterface";

const Pill = ({
  key,
  selectedPill,
  label,
  value,
  isActive,
  timestamp,
  valUrl,
  selectedIndex,
  setIndex,
  toggleIsActive,
}) => {
  let name = timestamp[selectedIndex];
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  const [datasetVal, setDatasetVal] = useState();
  const [selectedDate, setSelectedDate] = useState(1);
  const {getLayer}=useContext(LayerContext)
  const { selectedDataSet } = useContext(SelectedDataSet);
  // console.log(name, name);
  // console.log(selectedIndex)
  const data = value[name];
  const arr = timestamp
    .map((name) => {
      // if (value[name][valUrl].mean!=undefined) {
      //   // console.log(value[name][valUrl].mean)
      //   return (value[name][valUrl].mean)
      // }
      return (value[name][valUrl].mean)
      // return value[name] && value[name][valUrl].mean;
    })
    .filter(Boolean)
    .map(Number);
  // console.log(value[name][valUrl]);
  // console.log(arr);
  const arrMin = (Math.min(...arr).toFixed(4));
  const arrMax = (Math.max(...arr).toFixed(4));
  const fn = (x) => {
    // console.log(x);
    // if(x>30){
    //   x = Number(x.toString().slice(0,2))
    // }
    // console.log((x - arrMin) / (arrMax - arrMin==0?1:arrMax-arrMin) / 2 + 0.5,x,arrMin,arrMax);
    // return (x - arrMin) / (arrMax - arrMin==0?1:arrMax-arrMin) / 2 + 0.5
    // console.log(arrMin, arrMax,x);
    if (x == null) {
      return 5
    }
    if (arrMin === arrMax) {
        return 30; // or any constant value within your desired range
    } else {
        // Calculate the range and adjust for very small differences
        x = Math.max(arrMin, Math.min(x, arrMax));
    
    // Calculate the range
    var range = arrMax - arrMin;
    
    // Normalize the number between 0 and 1 using the range
    var normalizedValue = (x - arrMin) / range;
    
      // Scale the normalized value to fit between 5 and 30
      // console.log(normalizedValue * (30 - 5) + 5)
    return normalizedValue * (30 - 5) + 5;
      
    }
  };
  useEffect(() => {
    // console.log("in map")
    // console.log(value);
  },[selectedIndex])
  return (
    <span
      id={`${!isActive && valUrl =="Satellite True Color (10m)"?"trueColor":isActive  &&  valUrl=="Satellite True Color (10m)"?"activeonetrue": isActive && valUrl=="Satellite False Color (10m)"?"activeonefalse":  !isActive && valUrl=="Satellite False Color (10m)" && "falseColor"}`}
      className={"Pill" + (isActive ? " active" : "")}
      onClick={() => {
        // console.log(data[valUrl])
        // console.log(valUrl);
        // setSelectedDate(selectedIndex)
        toggleIsActive(data[valUrl]); 
        // console.log(data[valUrl])
      }}
    >
      <span>
        <span className="label">{label}</span>
        <div className={`${(valUrl=="Satellite True Color (10m)" || valUrl=="Satellite False Color (10m)") ? "dont-show":"unit"}`}>Unit : <span className="value">{ data &&  data[valUrl].unit=="none"?"No unit":data[valUrl].unit}</span></div>
        <div className={`${(valUrl=="Satellite True Color (10m)" || valUrl=="Satellite False Color (10m)") ? "dont-show":"unit"}`} >Value : <span className="value">{datasetVal!=undefined && datasetVal.label==label ?datasetVal.value=="none"||datasetVal.value==null?"No Values":(+datasetVal.value).toFixed(4):datasetVal==undefined && data[valUrl].mean=="none"||data[valUrl].mean==null?"No Values":(+data[valUrl].mean).toFixed(4)}</span></div>
      </span>

      <div className={`${(valUrl=="Satellite True Color (10m)" || valUrl=="Satellite False Color (10m)") ? "dont-show":"shortLineChart"}`} >
        {timestamp.map((name, id) => {
          const isSelected = selectedIndex === id;
          const data = value[name];
          if (data[valUrl].mean!=null || data[valUrl].mean!="none") {
            return (
                <span
                id="shortLineBar"
                className={isSelected ? "active" : "linebar"}
                style={{ height:fn(data[valUrl].mean=="none"||data[valUrl].mean==null?null:((+data[valUrl].mean).toFixed(4))) }}
                key={id}
                onMouseEnter={() => {
                  setDatasetVal({
                    label: label,
                    value: data[valUrl].mean=="none"?0:(+data[valUrl].mean).toFixed(4)
                  })
                }}
                onMouseLeave={() => {
                  setDatasetVal();
                }}
              ></span>
            
            );
          } else return null;
        })}
      </div>
    </span>
  );
};

const Content = ({ domain, dataList, timestamp, selectedIndex, setIndex }) => {
  const [selectedPills, setSelectedPills] = React.useState([]);
  const { getScrollId } = useContext(ScrollToContext);
  // console.log(selectedPills)
  const { getSelectedIdx } = useContext(SelectedDataSet);
  const { choosenData } = useContext(ChoosenDataSet);
  const { selectedIdx } = useContext(SelectedDataSet);
  const { getSelectedDataSet } = useContext(SelectedDataSet)
  const { newAddDataSet } = useContext(NewAddDomain)
  const { domainName } = useContext(DomainContext);
  const { selectedDataSet } = useContext(SelectedDataSet);
  const { city } = useContext(CityContext);
  const { getLoading } = useContext(LoadingContext);
  const { playOn } = useContext(PlayContext);
  const { getPlay } = useContext(PlayContext);
  const { layerAdded } = useContext(LayerAddContext);
  const [agriDomain, setAgriDomain] = useState([{
          name: "Satellite True Color (10m)",
          url: "Satellite True Color (10m)"
        },
        {
          name: "Vegetation Index",
          url: "Vegetation Index"
        },
        {
          name: "Water Index",
          url: "Water Index"
        }, {
          name: "Moisture Index",
          url: "Moisture Index"
        },
        {
          name: "Soil Temperature",
          url: "Soil Temperature"
        },]);
  const [climateDomain, setClimateDomain] = useState([{
          name: "Sulphur Dioxide (SO2)",
          url: "Sulphur Dioxide (SO2)"
        },
        {
          name: "Methane (CH4)",
          url: "Methane (CH4)"
        }, {
          name: "Carbon Monoxide (CO)",
          url: "Carbon Monoxide (CO)"
        },
        {
          name: "Nitrogen Dioxide (NO2)",
          url: "Nitrogen Dioxide (NO2)"
        }]);
  const [riskDomain, setRiskDomain] = useState([{
          name: "Power Plant Locations",
          url: "Power Plant Locations"
        },
        {
          name: "Surface Pressure",
          url: "Surface Pressure"
    }]);
  const [domainLists, setDomainLists] = useState();
  const {getLayer}=useContext(LayerContext)
  useEffect(() => {
    if (domainName == "Agriculture") {
      // console.log(agriDomain)
      setDomainLists(agriDomain)
    }
      else if (domainName == "Climate Change") {
      setDomainLists(climateDomain)
      }
    else if (domainName == "Risk") {
      setDomainLists(riskDomain)
    }
    setSelectedPills([]);
    getLoading(false);
  }, [domainName,city])
  useEffect(() => {
    getSelectedIdx(selectedPills);
    // getSelectedDataSet(domain[selectedPills[0]])
  }, [selectedPills])
  
  useEffect(() => {
    // console.log("in dashboard")
    // console.log(selectedIdx);
    if (choosenData && selectedIdx && selectedIdx.length > 0) {
      getLayer(false);
      getSelectedDataSet(newAddDataSet==undefined ? dataList[timestamp[selectedIndex]][choosenData[selectedIdx[0]].name]:newAddDataSet &&dataList[timestamp[selectedIndex]][newAddDataSet[selectedIdx[0]].name])
    }
  }, [selectedIndex])
  // console.log(layerAdded);
  const notify = (msg) => toast.warn(msg, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme:"dark",
    });
  return (
    <div className="InfoHolder">
      {domain.map((data2, id2) => {
        const isActive = selectedPills.includes(id2);
        const toggleIsActive = (a) => {
          // console.log(a);
          if (isActive) {
            setSelectedPills((arr) => {
              if (playOn == true) {
                notify('You can not remove dataset at the time of playing');
                // getPlay(false);
                // getSelectedDataSet();
                // getLoading(true);
                // getLayer(false);
                // console.log(arr);
                if (arr[0] == 0) {
                  return [0]
                }
                return arr.filter((x)=>x)
              }
              else if (selectedDataSet && layerAdded == false) {
                notify("Wait...Image is loading");
                // console.log(arr);
                if (arr[0] == 0) {
                  return [0]
                }
                return arr.filter((x)=>x)
              }
              else {
                // console.log("in")
                getSelectedDataSet();
                getLoading(true);
                getLayer(false);
                return arr.filter((x) => x !== id2);
              }
              
            });
          } else {
            // console.log("inside else");
            setSelectedPills((arr) => {
              if (playOn == true) {
                return [id2];
              }
              else if (selectedDataSet && layerAdded == false) {
                notify("Wait...Image is loading");
                // console.log(arr);
                if (arr[0] == 0) {
                  return [0]
                }
                return arr.filter((x)=>x)
              }
              else {
                getSelectedDataSet(a);
                getLayer(false);
                getScrollId(true);
                return [id2];
              }
              
            });
          }
        };
        return (
          <Pill
            key={id2}
            selectedPill={selectedPills}
            label={data2.name}
            valUrl={data2.url}
            value={dataList}
            timestamp={timestamp}
            selectedIndex={selectedIndex}
            setIndex={setIndex}
            isActive={isActive}
            toggleIsActive={toggleIsActive}
          />
        );
      })}
    </div>
  );
};
const Dashboard = ({ locData }) => {
  
  // console.log(locData);
  
  const { getContent } = useContext(ContentContext)
  const { getChoosenData } = useContext(ChoosenDataSet)
  const { newAddDataSet } = useContext(NewAddDomain);
  const {getDomainUrl}=useContext(DomainContext)
  const { city } = useContext(CityContext);
  const { domainUrl } = useContext(DomainContext);
  const { newAdd } = useContext(NewAddDomain);
  const {choosenData}=useContext(ChoosenDataSet)
  // console.log(newAddDataSet);
  let params = useParams();
  // console.log(params)
  const url = params.domain;
  // console.log(url);
  const cityIndex = locData.findIndex(
    (data) => data.locationURL === params.city
  );
  const content = locData[cityIndex];
  useEffect(() => {
    getContent(content)
  },[content])
  const filterContent = locData.filter(
    (data) => data.locationURL === params.city
  );
  // console.log(filterContent);
  // console.log("locData", defaultCityIndex);
  // console.log("Filtered location", params.city);

  const {
    latitude,
    longitude,
    accuracy,
    boundingbox,
    domainData,
    dataList,
    timestamp,
    location,
    country
  } = filterContent[0];

  const [selectedIndex, setIndex] = React.useState(4);
  // console.log(selectedIndex);
  const {
    agriculture,
    climate_change,
    risk,
  } = domainData;

  const [domain, setDomain] = useState();
  const [agriDomain, setAgriDomain] = useState([
        {
          name: "Satellite True Color (10m)",
          url: "Satellite True Color (10m)"
        },
        {
          name: "Satellite False Color (10m)",
          url: "Satellite False Color (10m)"
        },
        {
          name: "Vegetation Index",
          url: "Vegetation Index"
        },
        {
          name: "Water Index",
          url: "Water Index"
        }, {
          name: "Moisture Index",
          url: "Moisture Index"
        },
        {
          name: "Soil Temperature",
          url: "Soil Temperature"
        },
        {
          name: "Surface Pressure",
          url: "Surface Pressure"
        },
        {
          name: "Specific Humidity",
          url: "Specific Humidity"
        },
        {
          name: "Soil Moisture",
          url: "Soil Moisture"
        },
        {
          name: "Land Surface Temperature",
          url: "Land Surface Temperature"
        },
  ]);
  const [climateDomain, setClimateDomain] = useState([
        {
          name: "Satellite True Color (10m)",
          url: "Satellite True Color (10m)"
        },
        {
          name: "Sulphur Dioxide (SO2)",
          url: "Sulphur Dioxide (SO2)"
        },
        {
          name: "Methane (CH4)",
          url: "Methane (CH4)"
        }, {
          name: "Carbon Monoxide (CO)",
          url: "Carbon Monoxide (CO)"
        },
        {
          name: "Nitrogen Dioxide (NO2)",
          url: "Nitrogen Dioxide (NO2)"
        },
        {
          name: "UV Aerosol Index",
          url: "UV Aerosol Index"
        },
        {
          name: "Formaldehyde (HCHO)",
          url: "Formaldehyde (HCHO)"
        },
        {
          name: "Ozone (O3)",
          url: "Ozone (O3)"
        },
        {
          name: "Land Surface Temperature",
          url: "Land Surface Temperature"
        },
        {
          name: "Night Lights",
          url: "Night Lights"
        },
        
    ]);
  const [riskDomain, setRiskDomain] = useState([
        {
          name: "Power Plant Locations",
          url: "Power Plant Locations"
        },
        {
          name: "Fire Radiative Power",
          url: "Fire Radiative Power"
        },
        {
          name: "Burned Area Age",
          url: "Burned Area Age"
        },
        {
          name: "Population",
          url: "Population"
        },
        {
          name: "Population (>35y old)",
          url: "Population (>35y old)"
        },
        {
          name: "Population (<35y old)",
          url: "Population (<35y old)"
        },
        {
          name: "Satellite True Color (10m)",
          url: "Satellite True Color (10m)"
        },
        {
          name: "Snow Index",
          url: "Snow Index"
        },
  ]);
 
  // console.log(newAddDataSet);
  useEffect(() => {
    if (url === "agriculture") {
    getChoosenData(agriDomain)
      setDomain(agriDomain);
  }
    if (url === "climate_change") {
    getChoosenData(climateDomain)
      setDomain(climateDomain)
      
  }
    if (url === "risk") {
    getChoosenData(riskDomain)
    setDomain(riskDomain);
      
    }
},[locData,url])
  useEffect(() => {
    if (newAddDataSet) {
      setDomain(newAddDataSet)
    }
  }, [newAddDataSet])
  // console.log(domain);
  function openMap() {
    const mapDiv = document.getElementById("map");
    if (screenfull.isEnabled) {
      screenfull.toggle(mapDiv);
    }
  }
  return (
    <div id="map" onClick={
      () => {
        // openMap();
      }
    }>
      <Alert/>
      <Title country={country} Label={location} currentCityIndex={cityIndex} locData={locData} />
      <Menu DomainList={content.domains} />
      {!isMobile ? (
        <div>
          <div className="dashContainer">
            <div className="InfoContainer">
                {domain ? (
                  <div>
                  <Content
                    domain={domain}
                    dataList={dataList}
                    timestamp={timestamp}
                    selectedIndex={selectedIndex}
                    setIndex={setIndex}
                    />
                    <Link onClick={() => {
                    localStorage.setItem("dataset", JSON.stringify(choosenData))
                    newAdd(newAddDataSet);
                  }} to="/customise-data">
                    <div className="custom-data-btn">
                      Customise Data
                      <FaPlus style={{
                        fontSize: "13px",
                        marginTop:"2px"
                      }}/>
                    </div>
                    </Link>
                  </div>
                ) : null}
              {/* <Link to="/">Save custom data</Link> */}
            </div>
            <div className="Map-div">
            <Map
              latitude={latitude}
              longitude={longitude}
              accuracy={accuracy}
              boundingbox={boundingbox}
              timestamp={timestamp}
              selectedIndex={selectedIndex}
                setIndex={setIndex}
                locData={locData}
              />
              </div>
          </div>
          <div>
            <ConnectNowInterface/>
          </div>
          <div style={{marginTop:"5%"}}>
            <Heading type="H2">Time Series</Heading>

            <Graph />
            <BlogPosting/>
          </div>
        </div>
      ) : (
        <div className="dashContainer mobile">
          <Map
            latitude={latitude}
            longitude={longitude}
            accuracy={accuracy}
            boundingbox={boundingbox}
            timestamp={timestamp}
            selectedIndex={selectedIndex}
            setIndex={setIndex}
          />
          <div>
            <div className="InfoContainer">
              <div>
                {domain ? (
                  <Content
                    domain={domain}
                    dataList={dataList}
                    timestamp={timestamp}
                    selectedIndex={selectedIndex}
                    setIndex={setIndex}
                  />
                ) : null}
              </div>

              <Link onClick={() => {
                localStorage.setItem("dataset",JSON.stringify(choosenData))
              }} to="/customise-data"><div className="custom-data-btn-mob">
                      Customise Data
                      <FaPlus style={{
                        fontSize: "13px",
                        marginTop:"2px"
                      }}/>
                  </div></Link>
              <div>
                <ConnectNowInterface/>
              </div>
              {/* <Link to={`${city}/agriculture`}>Save custom data</Link> */}
                <div style={{marginLeft:"6%"}}><Heading type="H2">Time Series</Heading></div>
                <Graph />
                <BlogPosting/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
